import { inject } from "@angular/core";
import {
  CanActivateFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { MsalService } from "@azure/msal-angular";
import { ConfigService } from "../../shared/services/config/config.service";

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const msalService = inject(MsalService);
  const configService = inject(ConfigService);

  try {
    const accounts = msalService.instance.getAllAccounts();
    if (accounts.length > 0) {
      return true;
    } else {
      const postLogoutUrl = configService.getConfigProperty("auth")?.postLogoutUrl || '/';
      router.navigate([postLogoutUrl]);
      return false;
    }
  } catch (error) {
    console.error('Auth guard error:', error);
    router.navigate(['/']);
    return false;
  }
};
